import { render, staticRenderFns } from "./_base-tag.vue?vue&type=template&id=b3b9c4c6&"
import script from "./_base-tag.vue?vue&type=script&lang=js&"
export * from "./_base-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3b9c4c6')) {
      api.createRecord('b3b9c4c6', component.options)
    } else {
      api.reload('b3b9c4c6', component.options)
    }
    module.hot.accept("./_base-tag.vue?vue&type=template&id=b3b9c4c6&", function () {
      api.rerender('b3b9c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-tag.vue"
export default component.exports